module.exports = __webpack_public_path__ + "static/media/config_icon.fc301699.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/config_icon.svg
// module id = 1785
// module chunks = 0